import cn from '../../../../utils/cn';

function CustomerDetailsStatus({ data }) {
    if (data?.isActiveAgency === false) {
        return (
            <div
                className={cn(
                    `h-10 bg-warning text-white rounded-lg mb-5 p-2 flex justify-start items-center gap-4`,
                    {
                        'bg-warning': data?.status === 'inactive'
                    }
                )}
            >
                <span>Please activate this agency to manage its customers.</span>
            </div>
        );
    }
    if (data?.isActiveAgency === true && data?.status === 'active') return null;

    if (data?.isActiveAgency === true && data?.status === 'inactive') {
        return (
            <div
                className={cn(
                    `h-10 bg-warning text-white rounded-lg mb-5 p-2 flex justify-start items-center gap-4`,
                    {
                        'bg-warning': data?.status === 'inactive'
                    }
                )}
            >
                <span>{data?.note}</span>
            </div>
        );
    }

    return null;
}

export default CustomerDetailsStatus;
